import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUser } from "../store/slices/session/sessionSelector";
import FirebaseAuthProvider from "../providers/FirebaseAuthProvider";
import Sidebar from "../components/sidebar/Sidebar";
import SidebarViewClient from "../components/sidebar/SidebarViewClient";
import { useUserRole } from "../hooks/useUserRole";
import { isClientPath } from "./ClientRoutesViewClient";
import NotFoundViewClient from "../pages/client/NotFoundViewClient";

const AuthenticatedRoute: React.FC = () => {
  const user = useSelector(selectUser);
  const location = useLocation();
  const { isClient } = useUserRole();

  // The sidebar lives here, outside the <Outlet />, so it stays mounted while
  // navigating between pages: its state and MUI ripple effects aren't reset by
  // every route change. It's position: fixed, so pages only need to keep
  // their left margin for it.
  return user ? (
    <FirebaseAuthProvider>
      {isClient ? <SidebarViewClient /> : <Sidebar />}
      {/* Para el cliente, lo que no es de su vista no existe */}
      {isClient && !isClientPath(location.pathname) ? (
        <NotFoundViewClient />
      ) : (
        <Outlet />
      )}
    </FirebaseAuthProvider>
  ) : (
    // Se recuerda adónde iba, para volver ahí después del login
    <Navigate to="/login" replace state={{ from: location }} />
  );
};

export default AuthenticatedRoute;
